import { ActionData } from '@bonusly/common-action-input';
import { Recipient } from '@bonusly/recipient-entities';

import { isEmailIdentifier } from '../../../../utils/email';

export const normalizeInviteEmail = (value: string): string => value.trim().replace(/^@+/, '').toLowerCase();

export const isInviteEmailRecipient = (recipient: Recipient): boolean => {
	if (recipient.type === 'group') return false;

	const username = normalizeInviteEmail(recipient.username || '');
	const id = normalizeInviteEmail(recipient.id || '');
	if (recipient.type === 'email') return isEmailIdentifier(username || id);

	// Handles unresolved mentions where type can still be username but id/username is the email.
	return isEmailIdentifier(username) && (id.includes('@') || id === username || !id);
};

export const getInviteEmailRecipients = (action: ActionData): string[] => {
	const recipientEmails = (action.recipients ?? [])
		.filter((recipient) => isInviteEmailRecipient(recipient))
		.map((recipient) => normalizeInviteEmail(recipient.username || recipient.id))
		.filter((email) => isEmailIdentifier(email));

	return Array.from(new Set(recipientEmails));
};

export const buildEmailRecipient = (email: string): Recipient =>
	new Recipient({
		id: email,
		display_name: email,
		profile_pic_url: '',
		username: email,
		user_mode: 'email',
	});
